// extracted by mini-css-extract-plugin
module.exports = {"container":"comparedItemPhoto_container__2mWfW","imgContainer":"comparedItemPhoto_imgContainer__1byUA","img":"comparedItemPhoto_img__CuL_7","deleteIcon":"comparedItemPhoto_deleteIcon__DOsC9","cross":"comparedItemPhoto_cross__33pUK"};
    if(module.hot) {
      // 1745908314333
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  